import { call, put, select, takeLatest } from 'redux-saga/effects';
import { LOAD_USER, CHANGE_USER } from './constants';
import {
  loadUserSuccess,
  loadUserError,
  changeUserSuccess,
  changeUserError,
} from './actions';

import _local from 'utils/localStorageUtils';
import requestWrapper from 'utils/requestWrapper';
import api from 'utils/api';
const { endpoint } = api;

export function* loadUser(action) {
  try {
    // we retrieve the token from the local storage
    const currentUser = _local.getLocalUser();
    const { id } = action;

    let userData = false;
    // we get the campaigns linked to the user
    if (!!id) {
      userData = yield requestWrapper(
        'GET',
        endpoint?.users?.singleForSchool(id),
        '',
        currentUser.token
      );
    }

    if (!id && !userData) {
      yield put(loadUserSuccess(false));
    } else {
      yield put(loadUserSuccess(userData));
    }
  } catch (error) {
    yield put(loadUserError(error));
  }
}


// Individual exports for testing
export default function* usersDetailSaga() {
  // See example in containers/HomePage/saga.js
  yield takeLatest(LOAD_USER, loadUser);
}
